import React from 'react';
import { Link } from 'react-router-dom';
import HeadingComponent from './headingComponent/HeadingComponent';
import img1 from '../assets/knowledgeCenter/1.jpg';
import img2 from '../assets/knowledgeCenter/3.jpg';
import img3 from '../assets/knowledgeCenter/5.jpg';
import img4 from '../assets/knowledgeCenter/4.jpg';
import KnowledgePage from './knowledgePage/KnowledgePage';

const KnowledgeCard = ({
	imgSrc,
	title,
	description,
	knowledgeId,
	setKnowledgeID,
}) => {
	const goToTopBtn = () => {
		window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
	};

	return (
		<div className='col mb-3'>
			<div className='card shadow-sm'>
				<img
					src={imgSrc}
					alt=''
					style={{
						height: '180px',
						width: '100%',
						objectFit: 'cover',
					}}
				/>
				<div
					className='card-body'
					style={{
						height: '180px',
						display: 'flex',
						flexDirection: 'column',
						margin: 'auto',
						justifyContent: 'center',
					}}
				>
					<h5 className='card-text my-2'>{title}</h5>
					<h6 className='card-text'>{description}</h6>
					<div className='my-2'>
						<div className='btn-group'>
							<button
								type='button'
								style={{
									background: '#003056',
									color: 'white',
									textDecoration: 'none',
								}}
								className='btn btn-sm btn-outline-dark'
							>
								<Link
									to='/knowledge'
									element={<KnowledgePage />}
									onClick={() => {
										goToTopBtn();
										setKnowledgeID(knowledgeId);
									}}
								>
									Read More
								</Link>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const KnowledgeCenter = ({ setKnowledgeID }) => {
	return (
		<div>
			<div className='container-fluid album'>
				<div className='container-fluid'>
					<HeadingComponent headerName={'Knowledge Center'} />
					<div className='row row-cols-1 row-cols-sm-2 row-cols-md-4'>
						<KnowledgeCard
							imgSrc={img1}
							title={'What are the Types of Solar Power Systems?'}
							description={'If you’re hunting for a great ...'}
							knowledgeId={1}
							setKnowledgeID={setKnowledgeID}
						/>
						<KnowledgeCard
							imgSrc={img2}
							title={'What are the Types of Solar Panels?'}
							description={'The main types of solar...'}
							knowledgeId={2}
							setKnowledgeID={setKnowledgeID}
						/>
						<KnowledgeCard
							imgSrc={img3}
							title={'How Solar Can Save My Monthly Electricity Bills?'}
							description={'Switching to solar energy...'}
							knowledgeId={3}
							setKnowledgeID={setKnowledgeID}
						/>
						<KnowledgeCard
							imgSrc={img4}
							title={'How to Avail Solar Subsidy, If I’m Eligible?'}
							description={'To avail solar subsidy in India ...'}
							knowledgeId={4}
							setKnowledgeID={setKnowledgeID}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default KnowledgeCenter;
